/* eslint-disable */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DividerOption } from '../../../divider/divider.model';
import { SearchResultItem } from '../../contracts/modal';

@Component({
    selector: 'nalco-result-list',
    templateUrl: './result-list.component.html',
    styleUrls: ['./result-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ResultListComponent {
 @Input() public heading: string | null = null;
  @Input() public items: SearchResultItem[] = [];
  @Input() public selectedItem: SearchResultItem | null = null;
  @Input() public searchInput = '';
  @Input() public listIconPath = '';
  @Input() public iconClass = '';
  @Input() public setHeight?: boolean = false;
  @Input() public displayResultCount?: boolean = false;
  @Input() public displaySecondaryText?: boolean = false;
  @Input() public enableMultiSelect?: boolean = false;
  @Output() public itemSelected = new EventEmitter<SearchResultItem | SearchResultItem[]>();
  // @Output() public multiSelectedItems? = new EventEmitter<SearchResultItem[]>();

  public dividerCss: DividerOption = {
    color: getComputedStyle(document.documentElement).getPropertyValue('--brand-light-blue').trim(),
    minLength: '100%',
    isHorizontal: true
  };

  public constructor(private translate: TranslateService) {

  }
  /**
   * @description Handles the selection of an item from the list.
   * 
   * @param {SearchResultItem} item - The selected item.
   * @returns {void}
   */

  public onItemSelect(item: SearchResultItem): void {
    if (this.enableMultiSelect) {
      return;
    }
    this.itemSelected.emit(item);
  }

  /**
   * @description TrackBy function for ngFor to improve performance
   * @param {number} index - The index of the item
   * @param {SearchResultItem} item - The item object
   * @returns {string | number} - The tracking identifier
   */
  public trackByIndex(index: number, item: SearchResultItem): string | number {
    return item?.id ?? index;
  }

  /**
   * @description Handles checkbox change for an item
   * @param {SearchResultItem} item - The item whose checkbox changed
   * @param {Event} event - The checkbox change event
   * @returns {void}
   */
  public onCheckboxChange(item: SearchResultItem, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    item.selected = checkbox.checked;
    
    // Emit the updated list of selected items
    const selectedItems = this.items.filter(i => i.selected);
    this.itemSelected.emit(selectedItems);
    
    // Prevent the click event from bubbling to the list item
    event.stopPropagation();
  }

  /**
   * @description Generates a unique checkbox ID for each item
   * @param {SearchResultItem} item - The item
   * @param {number} index - The item index
   * @returns {string} - The unique checkbox ID
   */
  public getCheckboxId(item: SearchResultItem, index: number): string {
    return `checkbox-${item.id || index}`;
  }


}